import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as applicationActions from "../../../actions/application";
import { APPLICATION_CONTEXTS } from "../../../constants";
import ReactPlayer from "react-player";
import NavigationBar from "../navigationBar";

class VideoPlayer extends Component {
  /**************
   * Properties *
   **************/

  /**
   * The component's current state.
   *
   * @property {object}  state
   * @public
   *
   **/
  state = {
    playing: true,
  };

  /*********************
   * Protected methods *
   *********************/

  /**
   * Handle button clicks
   *
   * @protected
   *
   **/
  handleClick = (e) => {
    if (this.props.context === APPLICATION_CONTEXTS.SERVICES) {
      this.playPause();
    }
  };

  /**
   * Handle key presses
   *
   * @protected
   *
   **/
  handleKeyUp = (e) => {
    if (this.props.context !== APPLICATION_CONTEXTS.SERVICES) {
      return;
    }
    switch (e.key) {
      case "b":
      case "B":
        this.handleVideoStopped();
        break;
      case "Enter":
      case " ":
        this.playPause();
        break;
      default:
        break;
    }
  };

  /**
   * Handle when the video pauses
   *
   * @protected
   *
   **/
  handlePause = (e) => this.setState({ playing: false });

  /**
   * Handle when a video ends
   *
   * @protected
   *
   */
  handleVideoEnds = () => {
    if (this.props.onVideoEnded) {
      this.props.onVideoEnded(this.props.id);
      if (this.props.navigationBar.doGoBack) {
        this.props.history.go(-1);
      } else {
        this.props.history.push(this.props.navigationBar.backRoute);
      }
    }
  };

  /**
   * Handle when a video is stopped by the user
   *
   * @protected
   *
   */
  handleVideoStopped = () => {
    if (this.props.onVideoEnded) {
      this.props.onVideoEnded(this.props.id);
    }
  };

  /**
   * Play or pause the video by setting the playing state
   *
   * @protected
   *
   **/
  playPause = () => this.setState({ playing: !this.state.playing });

  /*******************
   * Lifecycle hooks *
   *******************/

  /**
   * Performs various actions for components that will be mounted.
   *
   * Listen for key presses
   *
   * @protected
   *
   **/
  componentWillMount() {
    document.addEventListener("keyup", this.handleKeyUp);
  }

  /**
   * Performs various actions for components that will be unmounted.
   *
   * Stop listening for key presses
   *
   * @protected
   *
   **/
  componentWillUnmount() {
    document.removeEventListener("keyup", this.handleKeyUp);
  }

  /******************
   * Public methods *
   ******************/

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    return (
      <div className="video-player">
        <ReactPlayer
          tabIndex="0"
          url={this.props.src}
          playing={this.state.playing}
          loop={this.props.loopVideo || false}
          controls={this.props.showControls || true}
          width="100%"
          height="100%"
          onPause={this.handlePause}
          onEnded={this.handleVideoEnds}
          onError={this.handleVideoEnds}
          onClick={this.handleClick}
        />
        <NavigationBar
          {...this.props.navigationBar}
          history={this.props.history}
        />
      </div>
    );
  }
}

export default connect(
  (state) => ({
    context: state.application.currentContext,
  }),
  (dispatch) => ({
    actions: bindActionCreators(
      {
        ...applicationActions,
      },
      dispatch
    ),
  })
)(VideoPlayer);
